/* eslint-disable object-curly-newline */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import React, { useState, useEffect } from "react";

import Stack from "@mui/material/Stack";
import MUIAlert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";

import CancelOutlined from "@mui/icons-material/CancelOutlined";

import type { Histories } from "../Home";

import { OnGoingGridListItem } from "../../../logic/api/OnGoingGridListService";
import { currentDate, DateFormats, diffDay, parseJSDate, separateStartAndEndDate } from "../../../logic/datetime";
import { isELearning } from "../../../logic/utility/TrainingUtil";
import { isRequired } from "../../../logic/utility/isRequired";

const needAlert = (career: OnGoingGridListItem): string | false => {
    // eラーニングのみ
    if (!isELearning(career.careerTypeId)) return false;

    // 必須のみ
    if (!isRequired(career.compulsoryId)) return false;

    // 実施期間あり
    if (!career.jissiKikan) return false;

    // 7日以内に実施期間が終了
    const itemEndDate = separateStartAndEndDate(career.jissiKikan).endDate;
    const nowDate = currentDate();
    const diff = diffDay(parseJSDate(itemEndDate, DateFormats.YYYYMMDDHHMM)!, nowDate);
    return diff >= 0 && diff <= 7 && itemEndDate;
};

const SompoAlert = ({ message, removeAlert }: { message: string; removeAlert: React.MouseEventHandler<HTMLButtonElement> }) => (
    <Tooltip title={message}>
        <MUIAlert
            variant="filled"
            icon={false}
            action={
                <Button color="inherit" size="small" onClick={removeAlert}>
                    <CancelOutlined />
                </Button>
            }
            sx={{
                backgroundColor: "primary.main",
                borderRadius: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiAlert-message": { textAlign: "center", width: "100%", pl: "64px" },
            }}
        >
            <Typography variant="h6">{message}</Typography>
        </MUIAlert>
    </Tooltip>
);

const Alert = (props: { histories: Histories }) => {
    const [careers, setCareers] = useState<OnGoingGridListItem[]>([]);
    const [endDate, setEndDate] = useState("");
    const { histories } = props;

    useEffect(() => {
        // 表示対象のみにフィルタリング
        let _endDate: string = "";
        const filtered = histories.careers.onGoing.filter((career) => {
            const __endDate = needAlert(career);
            if (!__endDate) return false;
            if (!_endDate) _endDate = __endDate;
            return true;
        });

        setCareers(filtered);
        setEndDate(_endDate);
    }, [histories.careers.onGoing]);

    const removeAlert = () => {
        setCareers([]);
    };

    return (
        <Stack sx={{ width: "100%" }} spacing={0.1}>
            {careers.length > 0 && (
                <>
                    {/* 期限が近づいている講座が1件の場合は期日を表示し、2件以上の場合は件数のみ表示する */}
                    {careers.length === 1 ? (
                        <SompoAlert
                            message={`${careers.length}件の講座の受講期限が近づいています。(${endDate}まで)。忘れずに受講してください。`}
                            removeAlert={removeAlert}
                        />
                    ) : (
                        <SompoAlert
                            message={`${careers.length}件の講座の受講期限が近づいています。忘れずに受講してください。`}
                            removeAlert={removeAlert}
                        />
                    )}
                </>
            )}
        </Stack>
    );
};

export default Alert;
